import React from 'react';
import { Row, Col, Spin, Empty } from 'antd';
import { Waypoint } from 'react-waypoint';
import iconEmpty from 'assets/images/shape-icon-empty.png';
import i18next from 'i18next';
import { Contact } from 'generated/apis';
import ContactItem from '../BoardView/ContactItem';

const GridList = ({ data, total, isFetching, fetchNextPage }) => {
  const enableLoadMore = data?.length < total;

  return (
    <div className="grid-list">
      {data?.length ? (
        <>
          <Row gutter={[24, 24]}>
            {data?.map((item?: Contact, idx?: number) => (
              <Col key={String(idx)} xl={6} lg={8} md={12} xs={24}>
                <ContactItem item={item} />
              </Col>
            ))}
          </Row>
        </>
      ) : (
        <Empty
          image={iconEmpty}
          imageStyle={{ height: 160 }}
          className="text-gray-500 mt-70 mb-48"
          description={i18next.t('error.noDataFound')}
        />
      )}
      {isFetching && (
        <div className="flex-center mt-12">
          <Spin />
        </div>
      )}
      {enableLoadMore && <Waypoint onEnter={fetchNextPage} />}
    </div>
  );
};

export default GridList;
